import '98.css/dist/98.css';
import Program from './program';

Program.execute();
